import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

/**
 * Friendly empty state with a gradient icon medallion, title, optional
 * description and a call-to-action. Replaces bare AntD "No data".
 */
const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => (
  <div
    className="ui-animate-in"
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '56px 24px',
    }}
  >
    {icon && (
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 18,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 28,
          color: 'var(--color-primary)',
          background: 'var(--gradient-brand-soft)',
          marginBottom: 16,
        }}
      >
        {icon}
      </div>
    )}
    <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--color-text-primary)' }}>
      {title}
    </div>
    {description && (
      <div style={{ marginTop: 6, fontSize: 13, color: 'var(--color-text-tertiary)', maxWidth: 360 }}>
        {description}
      </div>
    )}
    {action && <div style={{ marginTop: 18 }}>{action}</div>}
  </div>
);

export default EmptyState;
